import { AxiosError } from "axios";
import { useQuery } from "react-query";
import axiosClient from "../utils/axiosClient";
import { QnAResponse } from "../types";

export const useAskQuestion = (
  executionId: string | number,
  question: string
) => {
  return useQuery<any, AxiosError<{ msg: string }>, QnAResponse>(
    ["qna", executionId, question],
    async () => {
      const data = await axiosClient.get<QnAResponse>(
        "/execution/askQuestion",
        {
          params: {
            executionId,
            question,
          },
          // 300s timeout
          timeout: 300000,
        }
      );
      return data.data;
    },
    {
      enabled: false,
      retry: false,
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );
};
